import buildAcrYamlModel from "./buildAcrYamlModel";
import { mapChapterIdForExport, wcagVersionFromText } from "./openAcrReportShared";

function asString(value) {
  if (value == null) return "";
  return String(value);
}

function standardName(standard) {
  const label = asString(standard?.label);
  const id = asString(standard?.id);
  const lower = `${label} ${id}`.toLowerCase();
  if (lower.includes("wcag")) {
    const version = wcagVersionFromText(label) || wcagVersionFromText(id);
    return version ? `WCAG ${version}` : "WCAG";
  }
  if (lower.includes("508")) return "Section 508";
  return label || id;
}

export default function buildAcrJsonModel(evaluation, catalog) {
  const acrYamlModel = buildAcrYamlModel(evaluation, catalog);
  const standards = Array.isArray(catalog?.standards) ? catalog.standards : [];

  return {
    title: acrYamlModel.title,
    product: acrYamlModel.product,
    author: acrYamlModel.author,
    vendor: acrYamlModel.vendor,
    report_date: acrYamlModel.report_date,
    last_modified_date: acrYamlModel.last_modified_date,
    version: acrYamlModel.version,
    notes: acrYamlModel.notes,
    evaluation_methods_used: acrYamlModel.evaluation_methods_used,
    legal_disclaimer: acrYamlModel.legal_disclaimer,
    repository: acrYamlModel.repository,
    feedback: acrYamlModel.feedback,
    license: acrYamlModel.license,
    related_acrs: acrYamlModel.related_acrs,
    catalog: acrYamlModel.catalog,
    standards: standards.map((standard) => {
      const chapterIds = Array.isArray(standard?.chapters) ? standard.chapters : [];
      return {
        name: standardName(standard),
        chapters: chapterIds.map((sourceChapterId) => {
          const chapterId = mapChapterIdForExport(sourceChapterId);
          const chapter = acrYamlModel.chapters?.[chapterId] ?? {};
          return {
            name: chapterId,
            notes: asString(chapter.notes),
            disabled: Boolean(chapter.disabled),
            criteria: Array.isArray(chapter.criteria) ? chapter.criteria : [],
          };
        }),
      };
    }),
  };
}
